var render, staticRenderFns
import script from "./edit-delta.vue?vue&type=script&lang=js"
export * from "./edit-delta.vue?vue&type=script&lang=js"
import style0 from "./edit-delta.vue?vue&type=style&index=0&id=a4232c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports